import React, { useCallback, useEffect, useState } from 'react';

const OfflineIcon = () => {
  const [counter, setCounter] = useState(0);

  useEffect(() => {
    const timer = setTimeout(() => {
      setCounter(prev => prev + 1);
    }, 200);
    return () => {
      clearTimeout(timer);
    };
  }, [counter]);

  const getFillColor = useCallback(
    index => {
      if (index === counter % 4) {
        return 'rgba(255, 102, 102, 100%)';
      }
      if (index === (counter + 1) % 4) {
        return 'rgba(255, 102, 102, 60%)';
      }
      if (index === (counter + 2) % 4) {
        return 'rgba(255, 102, 102, 40%)';
      }
      if (index === (counter + 3) % 4) {
        return 'rgba(255, 102, 102, 20%)';
      }
    },
    [counter]
  );

  return (
    (<svg
      width="14"
      height="11"
      viewBox="0 0 14 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-palette="OfflineIcon">
      <path d="M0 9H2V11H0V9Z" fill={getFillColor(0)} />
      <path d="M4 6H6V11H4V6Z" fill={getFillColor(1)} />
      <path d="M8 2H10V11H8V2Z" fill={getFillColor(2)} />
      <path d="M14 0H12V11H14V0Z" fill={getFillColor(3)} />
    </svg>)
  );
};

export default OfflineIcon;
